import { AxiosRequestConfig } from "axios";
import ApiService from "../../utils/api/api-service";

class PrivacyPolicyService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: `https://api.metasignapp.com/api/`,
      ...config,
    });
  }

  public GetPrivacy = async (): Promise<any> => {
    return this.get("/services/app/Configuration/GetPrivacyPolicy");
  };
}

export const PrivacyService = new PrivacyPolicyService();
